<template>
  <footer class="footer pt-2">
    <div class="hr-dy"></div>
    <section class="text-white text-center">
      <div class="container-fluid footer__container">
        <!--Grid row-->
        <div class="footer__row">
          <div class="footer__header">
            <div class="brand mb-4 mb-md-0">
              <div class="brand__image">
                <img
                  src="@/assets/brand/logo-square-transparent.webp"
                  alt="logo web smart solution"
                  class="img-fluid"
                />
              </div>
              <div class="brand__text">
                <h3>IttI</h3>
                <p>
                  Centre de formation vtc et taxi à Gennevilliers, dans les
                  Hauts-de-Seine (92), Vous propose ses formations Initiale,
                  continue, mobilité et passerelle pour devenir chauffeur de
                  taxi ou VTC. Rejoignez l'Institut Taxi et donnez un nouvel
                  élan à votre carrière dans le secteur du transport de
                  personnes.
                </p>
                <div class="hr-d separator"></div>
              </div>
            </div>

            <div class="footer__aside">
              <div class="footer__panel footer__panel--social">
                <SocialMedia :light="true" />
              </div>
              <div class="footer__panel footer__panel--contact">
                <div class="contact-card">
                  <h5 class="jaapokki">Nous contacter</h5>
                  <ul class="list-unstyled">
                    <li>
                      <button
                        type="button"
                        class="contact-card__item"
                        aria-label="Voir l'adresse de l'Institut Taxi"
                        @click="openAddressModal"
                      >
                        <span class="contact-card__icon">
                          <i class="fas fa-home"></i>
                        </span>
                      </button>
                    </li>
                    <li>
                      <a
                        href="mailto:contact@institut-taxi.fr"
                        class="contact-card__item"
                        aria-label="Envoyer un email"
                      >
                        <span class="contact-card__icon">
                          <i class="fas fa-envelope"></i>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a
                        href="tel:+33141112232"
                        class="contact-card__item"
                        aria-label="Appeler le téléphone fixe"
                      >
                        <span class="contact-card__icon">
                          <i class="fas fa-phone"></i>
                        </span>
                      </a>
                    </li>
                    <li>
                      <a
                        href="tel:+33787185918"
                        class="contact-card__item"
                        aria-label="Appeler le téléphone mobile"
                      >
                        <span class="contact-card__icon">
                          <i class="fas fa-mobile"></i>
                        </span>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="footer__links">
            <div class="mb-4 mb-md-0">
              <h4 class="text-uppercase">Formations taxi</h4>

              <ul class="list-unstyled mb-0">
                <li>
                  <router-link to="/formation-taxi-initiale"
                    >formation initiale taxi</router-link
                  >
                </li>
                <li>
                  <router-link to="/formation-taxi-continue"
                    >formation continue taxi</router-link
                  >
                </li>
                <li>
                  <router-link to="/formation-taxi-pratique-seule"
                    >examen pratique taxi</router-link
                  >
                </li>
                <li>
                  <router-link
                    to="/formation-mobilite-passerelle-taxi-vers-vtc"
                    class="footer-link footer-link--single-line"
                    >passerelle Taxi
                    <span class="footer-link__arrow" aria-hidden="true">→</span>
                    VTC</router-link
                  >
                </li>
              </ul>
            </div>

            <div class="mb-4 mb-md-0">
              <h4 class="text-uppercase">Formations vtc</h4>

              <ul class="list-unstyled mb-0">
                <li>
                  <router-link to="/formation-vtc-initiale" class="text-white"
                    >formation initiale vtc</router-link
                  >
                </li>
                <li>
                  <router-link to="/formation-vtc-continue" class="text-white"
                    >formation continue vtc</router-link
                  >
                </li>
                <li>
                  <router-link
                    to="/formation-vtc-pratique-seule"
                    class="text-white"
                    >examen pratique vtc</router-link
                  >
                </li>
                <li>
                  <router-link
                    to="/formation-mobilite-passerelle-vtc-vers-taxi"
                    class="text-white footer-link footer-link--single-line"
                    >passerelle VTC
                    <span class="footer-link__arrow" aria-hidden="true">→</span>
                    Taxi</router-link
                  >
                </li>
              </ul>
            </div>

            <div class="mb-4 mb-md-0">
              <h4 class="text-uppercase">taxi &#38; vtc</h4>

              <ul class="list-unstyled mb-0">
                <li>
                  <router-link
                    to="/formation-mobilite-taxi-92"
                    class="text-white"
                    >formation mobilité 92</router-link
                  >
                </li>
                <li>
                  <router-link
                    to="/formation-mobilite-taxi-92"
                    class="text-white"
                    >formation mobilité 75</router-link
                  >
                </li>
                <li>
                  <router-link
                    to="/formations-taxi-vtc/modulables"
                    class="text-white"
                    >Accélérées semaine</router-link
                  >
                </li>
                <li>
                  <router-link
                    to="/formations-taxi-vtc/modulables"
                    class="text-white"
                    >Accélérées week-end</router-link
                  >
                </li>
              </ul>
            </div>
            <div class="footer__logos mb-4 mb-md-0">
              <div class="footer__logo-slot footer__logo-slot--primary">
                <a
                  v-if="isHomePage"
                  href="https://acrobat.adobe.com/id/urn:aaid:sc:EU:7bdb2fab-e4ba-451e-abc0-bb51c5a00dc1"
                  class="qualiopi"
                >
                  <img
                    src="@/assets/pictures/newpi.jpeg"
                    alt="qualiopi-logo"
                    width="170"
                    class="my-1"
                  />
                </a>
              </div>
              <div class="footer__logo-slot footer__logo-slot--secondary">
                <a href="https://orizon-assurance.fr/" class="qualiopi">
                  <img
                    src="@/assets/pictures/orizon-logo.webp"
                    alt="horizon-logo"
                    width="170"
                    class="my-1"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-if="isAddressModalOpen"
        class="footer-modal"
        @click.self="closeAddressModal"
      >
        <div
          class="footer-modal__dialog"
          role="dialog"
          aria-modal="true"
          aria-labelledby="footer-address-title"
        >
          <button
            type="button"
            class="footer-modal__close"
            aria-label="Fermer la fenêtre d'adresse"
            @click="closeAddressModal"
          >
            ×
          </button>
          <h6 id="footer-address-title" class="jaapokki footer-modal__title">
            Adresse
          </h6>
          <textarea
            ref="addressField"
            class="footer-modal__address"
            readonly
            :value="addressText"
          ></textarea>
          <div class="footer-modal__actions">
            <button
              type="button"
              class="footer-modal__button"
              @click="copyAddress"
            >
              Copier
            </button>
            <button
              type="button"
              class="footer-modal__button footer-modal__button--ghost"
              @click="closeAddressModal"
            >
              Fermer
            </button>
          </div>
          <p v-if="addressCopied" class="footer-modal__feedback">
            Adresse copiée.
          </p>
        </div>
      </div>

      <!-- Footer -->
    </section>
    <!-- Footer -->
    <div class="text-center text-white">
      <!-- Grid container -->
      <div class="container p-4 pb-0">
        <!-- Section: CTA -->
        <section class="">
          <p class="d-flex justify-content-center align-items-center my-4">
            <span class="me">Demandez votre devis</span>
            <button
              type="button"
              class="btn btn-outline-light btn-rounded btn-contact"
            >
              <a class="" href="/contact"> Contact </a>
            </button>
          </p>
        </section>
        <!-- Section: CTA -->
      </div>
      <!-- Grid container -->

      <!-- Copyright -->
      <div class="text-center p-3 copyright">
        <a class="text-white" href="/mentions"
          ><span
            ><span>©</span> {{ copyrightYears }} Mentions légales & Copyright:
            INSTITUT TAXI <br /></span
        ></a>
        <a class="text-white" href="https://malaweb.fr/">Powered by Malaweb</a>
      </div>
      <!-- Copyright -->
    </div>
    <!-- Footer -->
  </footer>
</template>

<script>
import SocialMedia from "@/components/partials/SocialMedia.vue";
export default {
  name: "FooterBase",
  components: { SocialMedia },
  data() {
    return {
      isAddressModalOpen: false,
      addressCopied: false,
      addressText: "10 rue de la Sablière,\n92230 Gennevilliers",
    };
  },
  computed: {
    isHomePage() {
      const normalizedPath = this.$route.path.replace(/\/+$/, "") || "/";

      return normalizedPath === "/" || normalizedPath === "/home";
    },
    copyrightYears() {
      const startYear = 2023;
      const currentYear = new Date().getFullYear();

      return currentYear <= startYear
        ? `${startYear}`
        : `${startYear}-${currentYear}`;
    },
  },
  methods: {
    openAddressModal() {
      this.isAddressModalOpen = true;
      this.addressCopied = false;

      this.$nextTick(() => {
        const field = this.$refs.addressField;
        if (field && typeof field.focus === "function") {
          field.focus();
        }
        if (field && typeof field.select === "function") {
          field.select();
        }
      });
    },
    closeAddressModal() {
      this.isAddressModalOpen = false;
      this.addressCopied = false;
    },
    async copyAddress() {
      try {
        if (navigator.clipboard && navigator.clipboard.writeText) {
          await navigator.clipboard.writeText(this.addressText);
        } else {
          const field = this.$refs.addressField;
          if (field && typeof field.select === "function") {
            field.focus();
            field.select();
            document.execCommand("copy");
          }
        }
        this.addressCopied = true;
      } catch (error) {
        const field = this.$refs.addressField;
        if (field && typeof field.select === "function") {
          field.focus();
          field.select();
        }
      }
    },
  },
};
</script>

<style scoped lang="scss">
.footer {
  background-color: $color-primary;
}

.footer__container {
  width: 100%;
}

.footer__row {
  width: 100%;
  min-width: 0;
  max-width: 1240px;
  margin: 0 auto;
  padding: 5px 24px 0;
  @media screen and (max-width: 767px) {
    padding: 5px 18px 0;
  }
}

.footer__header {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 18px;
  width: 100%;
  @media screen and (min-width: 992px) {
    display: grid;
    grid-template-columns: 170px minmax(440px, 1fr) 160px 160px;
    gap: 56px;
    align-items: center;
  }
}

.footer__aside {
  width: 100%;
  display: grid;
  gap: 22px;
  @media screen and (min-width: 992px) {
    display: contents;
  }
}

.footer__panel {
  width: 100%;
  display: flex;
  align-items: stretch;
  justify-content: center;
  @media screen and (max-width: 991px) {
    width: 100%;
  }
}

.footer__panel > * {
  width: 100%;
}

.footer__panel--social {
  @media screen and (min-width: 992px) {
    grid-column: 3;
    align-self: center;
  }
}

.footer__panel--contact {
  @media screen and (min-width: 992px) {
    grid-column: 4;
    align-self: center;
  }
}

.brand {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  &.mb-4,
  &.mb-md-0 {
    margin-bottom: 0 !important;
  }
  @media screen and (min-width: 992px) {
    grid-column: 1 / span 2;
    display: grid;
    grid-template-columns: 170px minmax(0, 1fr);
    gap: 22px;
    align-items: start;
    align-self: start;
  }
}

.brand__image {
  text-align: left;
  @media screen and (min-width: 992px) {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
  }
}

.brand__image img {
  width: 170px;
  max-width: 170px;
  margin: 0 10px;
  @media screen and (min-width: 992px) {
    margin: 0 0 0 -24px;
  }
}

.brand__text {
  min-width: 0;
}

.brand__text h3 {
  color: $color-secondary;
  font-family: "cunia", "Arial Black", Arial, sans-serif;
  font-size: 3em;
  margin: 0 0 8px;
  text-align: center;
  @media screen and (min-width: 992px) {
    text-align: left;
  }
}

.brand__text p {
  font-size: 1rem;
  margin: 0;
  text-align: center;
  @media screen and (min-width: 992px) {
    font-size: 1.04rem;
    line-height: 1.56;
    text-align: left;
  }
}

.brand__text .separator {
  @media screen and (min-width: 992px) {
    margin: 12px 0 0;
  }
}

.footer__links {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  gap: 28px;
  margin: 44px auto 0;
  width: fit-content;
  max-width: 100%;
  @media screen and (min-width: 992px) {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    gap: 56px;
    width: 100%;
    max-width: none;
    align-items: flex-start;
  }
}

.footer__links h4 {
  color: $color-secondary;
  text-align: left;
  font-size: 1.26rem;
  @media screen and (min-width: 992px) {
    margin-bottom: 12px;
  }
}

.footer__links > div {
  width: auto;
  max-width: 100%;
  text-align: left;
  margin: 0;
  &.mb-4,
  &.mb-md-0 {
    margin-bottom: 0 !important;
  }
  @media screen and (min-width: 992px) {
    width: auto;
    max-width: none;
    flex: 0 0 auto;
    margin: 0;
  }
}

.footer__links ul {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: auto;
}

.footer__links li {
  margin-bottom: 5px;
  width: auto;
  text-align: left;
}

.footer__links a {
  color: $color-text-light;
  text-align: left;
  font-size: 1.04rem;
  line-height: 1.5;
}

.footer__logos {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  width: auto;
  max-width: 100%;
  @media screen and (min-width: 992px) {
    width: auto;
    max-width: none;
    align-items: flex-start;
    align-self: start;
    justify-self: start;
  }
}

.footer__logo-slot {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  width: 148px;
}

.footer__logo-slot--primary {
  min-height: 90px;
}

.footer__logo-slot--secondary {
  min-height: 52px;
}

.footer__logos img {
  display: block;
  margin: 0 !important;
  width: 148px;
  height: auto;
}

.footer .copyright {
  background-color: $color-secondary;
}

.footer .copyright span {
  color: $color-text;
  font-weight: bolder;
}

.footer .copyright span span {
  font-size: 1.2em;
}

.footer .me {
  color: $color-secondary;
  margin-right: 0;
}

.contact-card {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 100%;
  @media screen and (min-width: 992px) {
    width: fit-content;
    align-items: center;
  }
}

.contact-card h5 {
  color: $color-text-light;
  margin: 0 0 16px;
  min-height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  line-height: 1.1;
  text-align: center;
  white-space: nowrap;
}

.contact-card ul {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  justify-items: center;
  align-items: center;
  gap: 10px;
  margin: 0;
  padding: 0;
  width: auto;
}

.contact-card li {
  display: flex;
  justify-content: center;
  width: 100%;
}

.contact-card__item {
  padding: 0;
  border: 0;
  background: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: $color-text-light;
  box-sizing: border-box;
  transition: 0.2s;
  cursor: pointer;
}

.contact-card__item:hover {
  color: $color-secondary;
}

.contact-card__icon {
  width: 42px;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 7px;
  background: $color-secondary;
  color: $color-primary;
  flex: 0 0 auto;
  transition: transform 0.2s ease, background-color 0.2s ease, color 0.2s ease;
}

.contact-card i {
  color: inherit;
  font-size: 16px;
  margin: 0;
}

.contact-card__item:hover .contact-card__icon,
.contact-card__item:focus-visible .contact-card__icon {
  transform: translateY(-2px);
  background: #ffd25a;
}

.contact-card__item:focus-visible {
  outline: none;
}

@media screen and (max-width: 575px) {
  .footer__aside {
    gap: 14px;
  }

  .contact-card__icon {
    width: 40px;
    height: 40px;
  }

  .contact-card i {
    font-size: 15px;
  }
}

.footer__panel--social :deep(.social-media) {
  width: 100%;
  gap: 8px;
  @media screen and (min-width: 992px) {
    width: fit-content;
    align-items: center;
  }
}

.footer__panel--social :deep(.social-media__header) {
  gap: 8px;
}

.footer__panel--social :deep(.social-media h5) {
  margin: 0 0 8px;
  min-height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  line-height: 1.1;
  text-align: center;
  white-space: nowrap;
}

.footer__panel--social :deep(.social-media__grid) {
  gap: 10px;
  margin: 0;
  justify-content: center;
}

.footer__panel--social :deep(.social-media__link) {
  min-height: 0;
}

.footer__panel--social :deep(.social-media__icon) {
  width: 42px;
  height: 42px;
  border-radius: 7px;
}

.footer__panel--social :deep(.social-media__icon i) {
  font-size: 16px;
}

@media screen and (max-width: 575px) {
  .footer__panel--social :deep(.social-media) {
    width: auto;
  }

  .footer__panel--social :deep(.social-media__icon) {
    width: 40px;
    height: 40px;
  }

  .footer__panel--social :deep(.social-media__icon i) {
    font-size: 15px;
  }
}

.footer-link--single-line {
  white-space: nowrap;
}

.footer-link__arrow {
  color: $color-secondary;
  font-weight: 700;
}

.footer-modal {
  position: fixed;
  inset: 0;
  z-index: 1200;
  background: rgba(2, 12, 29, 0.62);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.footer-modal__dialog {
  position: relative;
  width: min(100%, 360px);
  padding: 24px 20px 18px;
  border-radius: 16px;
  background: #ffffff;
  color: $color-primary;
  box-shadow: 0 20px 48px rgba(0, 0, 0, 0.28);
}

.footer-modal__close {
  position: absolute;
  top: 10px;
  right: 12px;
  border: 0;
  background: transparent;
  color: $color-primary;
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
}

.footer-modal__title {
  margin: 0 0 14px;
  color: $color-primary;
  font-size: 1.2rem;
  text-align: left;
}

.footer-modal__address {
  width: 100%;
  min-height: 92px;
  padding: 12px 14px;
  border: 1px solid rgba(6, 52, 104, 0.2);
  border-radius: 12px;
  resize: none;
  font-size: 1rem;
  line-height: 1.45;
  color: $color-primary;
  background: #f7f9fc;
}

.footer-modal__actions {
  display: flex;
  gap: 10px;
  margin-top: 14px;
}

.footer-modal__button {
  border: 0;
  border-radius: 10px;
  padding: 10px 14px;
  background: $color-secondary;
  color: $color-primary;
  font-weight: 600;
  cursor: pointer;
}

.footer-modal__button--ghost {
  background: rgba(6, 52, 104, 0.08);
}

.footer-modal__feedback {
  margin: 10px 0 0;
  font-size: 0.95rem;
  color: #2b7a3d;
}

.footer .copyright a {
  font-size: 0.98rem;
  line-height: 1.45;
}

.btn-contact {
  margin-left: 16px;
  & a {
    color: $color-text-light;
  }
  &:hover {
    & a {
      color: $color-text;
    }
  }
}

.qualiopi {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 0;
}
</style>
